import axios from "axios";
import qs from "qs";
import { baseUrl } from "../config/EnVariables";
const token = localStorage.getItem("access_token");
const user = JSON.parse(localStorage.getItem("user"));
// const baseUrl = "http://localhost:8081/api";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};
const Branch = {
  getAllBranches: async () =>
    await axios.get(`${baseUrl}/branches`, {
      headers: headers,
    }),
  //Currencies

  createBranch: async (data) =>
    await axios.post(`${baseUrl}/branches`, data, {
      headers: headers,
    }),
  //Reports
  getGeneralLedger: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/general-ledger?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  getJournals: (data) =>
    axios.get(
      `${baseUrl}/general-journals/?branchId=${user.branchId}&page=0&size=35`,
      {
        headers: headers,
      }
    ),
  getTransactionLines: (journelId) =>
    axios.get(
      `${baseUrl}/transaction-lines/general-journal-lines?generalJournalId=${journelId}`,
      {
        headers: headers,
      }
    ),
  getTrialBalance: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/trial-balance/?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  getIncomeStatement: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/income-statement/?branchId=${user.branchId}&startDate=${data.startDate}&endDate=${data.endDate}`,
      {
        headers: headers,
      }
    ),

  getBalanceSheet: (data) =>
    axios.get(
      `${baseUrl}/transaction-lines/balance-sheet/?branchId=${user.branchId}`,
      {
        headers: headers,
      }
    ),
  update: (data, ID) =>
    axios.post(`buildings/updateBuilding`, { buildingid: ID, ...data }),

  getByMember: (ID, pagination, date) =>
    axios.get(
      `/transfer/member/${ID}?${qs.stringify(pagination)}&${qs.stringify(date)}`
    ),

  remove: (data) => axios.post("/buildings/removeBuilding", data),
};

export default Branch;
